module.exports = __webpack_public_path__ + "img/hand-tap.eb443edb.gif";